import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { takeWhile } from 'rxjs';
import * as _ from 'lodash';
import { ProductsTypeEnum } from '@app/forms/subscription/definition/interface';
export interface PageHeaderMenuItem {
  url: string;
  label: ProductsTypeEnum;
  current: boolean;
  icon?: string;
  iconColor?: string;
  iconTooltip?: string;
}
export interface PageHeaderMenu {
  synthese?: { url: string; label: string; current?: boolean };
  label?: string;
  items?: PageHeaderMenuItem[];
}

@Component({
    selector: 'pr-page-header-menu',
    templateUrl: './pr-page-header-menu.component.html',
    styleUrls: ['./pr-page-header-menu.component.scss'],
    standalone: false
})
export class PrPageHeaderMenuComponent implements OnInit, OnDestroy {
  private alive = true;
  private _menus: PageHeaderMenu;
  public get menus(): PageHeaderMenu {
    return this._menus;
  }
  @Input() public set menus(value: PageHeaderMenu) {
    this._menus = {};
    if (!value.items) return;
    this._menus = value;
    this.setItemCurrent();
    this._menus.items = _.sortBy(this._menus.items, 'label', 'asc');
    this._menus.items.forEach(item => {
      if (this.router.url.match(item.url)) {
        if (this.menus.synthese) this.menus.synthese.current = false;
        item.current = true;
      }
    });
  }

  constructor(protected router: Router) {
    this.router.events.pipe(takeWhile(() => this.alive)).subscribe(val => {
      if (val instanceof NavigationEnd) this.setCurrentWithUrl();
    });
  }

  ngOnInit() {}

  get current() {
    return this.menus.items ? this.menus.items.find(m => m.current) : null;
  }

  get synthese() {
    return this.menus.synthese && this.menus.synthese.current
      ? 'synthese current'
      : 'synthese';
  }

  setItemCurrent(i?) {
    if (this.menus.synthese) this.menus.synthese.current = false;
    this.menus.items.forEach(item => (item.current = false));
    if (i != null || i != undefined) this.menus.items[i].current = true;
    else if (this.menus.synthese) this.menus.synthese.current = true;
  }

  setCurrentWithUrl() {
    let currentItem = this.menus.items.find(
      item => item.url == this.router.url,
    );
    if (currentItem) this.setItemCurrent(this.menus.items.indexOf(currentItem));
    else this.setItemCurrent();
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
